module.exports = "\n\t<router-outlet></router-outlet>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/visualizador/visualizador.component.html
// module id = ./src/app/modules/visualizador/visualizador.component.html
// module chunks = main